<template>
	<div>
		<div class="gh-layout">
			<aside class="gh-intro">
				<h2 class="gh-intro__title">LOB</h2>
				<p class="gh-intro__desc">
					Settings for direct-mail campaigns over LOB — API credentials, synchronization interval and campaign senders.
				</p>
			</aside>

			<section class="gh-accounts">
				<div class="ada-card">
			<form v-if="settings" @submit.prevent="saveSettings">
				<div class="gh-section">
					<div class="gh-section__title">API</div>
					<div class="gh-field">
						<label>LOB API URL</label>
						<input type="text" class="form-control" v-model="settings.apiUrl" />
					</div>
					<div class="gh-field">
						<label>LOB API Version</label>
						<input type="text" class="form-control" v-model="settings.apiVersion" />
					</div>
					<div class="gh-field">
						<label>LOB API Key</label>
						<input type="text" class="form-control" v-model="settings.apiKey" />
					</div>
					<div class="gh-field">
						<label>LOB API Key Test</label>
						<input type="text" class="form-control" v-model="settings.apiKeyTest" />
					</div>
				</div>

				<div class="gh-section">
					<div class="gh-section__title">Synchronization</div>
					<div class="gh-field">
						<label>How often to check for new campaigns on LOB</label>
						<select
							@change="changeCronString('campaignsCheckInterval')"
							class="form-select"
							v-model="settings.campaignsCheckInterval"
						>
							<option value="">Do not check</option>
							<option value="hourly">Every hour (once in an hour)</option>
							<option value="daily">Every day (once per day)</option>
							<option value="weekly">Every week (once per week)</option>
							<option value="monthly">Every month (once per month)</option>
						</select>
					</div>
					<div class="mt-2">
						<button
							type="button"
							class="gh-save-btn"
							:disabled="syncingCampaigns"
							data-bs-toggle="modal"
							data-bs-target="#syncCampaignsModal"
						>
							<font-awesome-icon :icon="['fas', 'sync']" :class="{ 'fa-spin': syncingCampaigns }" />
							{{ syncingCampaigns ? 'Syncing…' : 'Synchronize Campaigns' }}
						</button>
					</div>
				</div>

				<div class="gh-section">
					<div class="gh-section__title">
						Campaign Senders
						<button type="button" class="gh-icon-btn ms-2" title="Add sender" @click="addSender()">
							<font-awesome-icon :icon="['fas', 'plus']" />
						</button>
					</div>
					<div class="row gx-2 lob-senders-head">
						<div class="col-3">Name</div>
						<div class="col-4">Address Street</div>
						<div class="col-2">City</div>
						<div class="col-1">State</div>
						<div class="col-1">ZIP</div>
					</div>
					<div :key="index" class="row gx-2 mb-2 align-items-center" v-for="(sender, index) in settings.senders">
						<div class="col-3">
							<input type="text" class="form-control" v-model="sender.name" />
						</div>
						<div class="col-4">
							<input type="text" class="form-control" v-model="sender.address_line1" />
						</div>
						<div class="col-2">
							<input type="text" class="form-control" v-model="sender.address_city" />
						</div>
						<div class="col-1">
							<input type="text" class="form-control" v-model="sender.address_state" />
						</div>
						<div class="col-1">
							<input type="text" class="form-control" v-model="sender.address_zip" />
						</div>
						<div class="col-auto">
							<button type="button" class="gh-icon-btn" title="Remove sender" @click="removeSender(index)">
								<font-awesome-icon :icon="['fas', 'trash-alt']" />
							</button>
						</div>
					</div>
				</div>
			</form>
				</div>
			</section>
		</div>

		<hr class="gh-divider" />

		<div class="gh-save-row">
			<button v-if="settings" class="gh-save-btn" @click="saveSettings">
				<i class="fas fa-save"></i>
				Save changes
			</button>
		</div>
		<!-- Modal Sync Campaigns from LOB -->
		<div
			class="modal fade"
			id="syncCampaignsModal"
			tabindex="-1"
			aria-labelledby="syncCampaignsModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<form v-if="settings" @submit.prevent="syncCampaigns">
						<div class="modal-header">
							<h5 class="modal-title" id="syncCampaignsModalLabel">Synchronize Campaigns</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="row">
								<div class="col-md-6">
									<div class="form-input">
										<label for=""> From</label>
										<input type="date" v-model="from" name="from" required class="form-control" />
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-input">
										<label for=""> To</label>
										<input
											required
											:disabled="from === null"
											:min="from"
											type="date"
											v-model="to"
											class="form-control"
											name="to"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button
								type="button"
								@click="clearSyncData()"
								class="btn btn-secondary"
								data-bs-dismiss="modal"
							>
								Cancel
							</button>
							<button type="submit" class="btn btn-primary">Synchronize</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import { Modal } from 'bootstrap'
export default {
	name: 'LOBSettings',
	data() {
		return {
			name: 'LobSettings',
			type: 'settings',
			settings: {
				campaignsCheckInterval: 'daily',
				campaignsCheckIntervalString: '0 0 * * *',
				apiKey: '',
				apiKeyTest: '',
				apiVersion: '',
				apiUrl: '',
				senders: [],
				// Always-on receivers are managed under Auto Campaigns > Settings >
				// Receivers, but they live in this same settings blob - keep the key
				// here so a first save from this screen cannot drop them.
				receivers: [],
			},
			syncingCampaigns: false,
			$syncCampaignsModal: null,
			from: null,
			to: null,
		}
	},
	created() {
		this.getSettings()
	},
	mounted() {
		this.$syncCampaignsModal = new Modal('#syncCampaignsModal')
	},
	methods: {
		getSettings() {
			restApi
				.get('/settings', { params: { name: this.name, type: this.type } })
				.then(({ data }) => {
					if (data) {
						this.settings = JSON.parse(data.data)
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		saveSettings() {
			restApi
				.post('/settings', {
					name: this.name,
					type: this.type,
					data: JSON.stringify(this.settings),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.settings = data.data
					this.$swal.fire({
						icon: 'success',
						title: 'Settings successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		changeCronString(period) {
			if (this.settings[period] === 'hourly') {
				this.settings[period + 'String'] = '0 * * * *'
			}
			if (this.settings[period] === 'daily') {
				this.settings[period + 'String'] = '0 0 * * *'
			}
			if (this.settings[period] === 'weekly') {
				this.settings[period + 'String'] = '0 0 * * 0'
			}
			if (this.settings[period] === 'monthly') {
				this.settings[period + 'String'] = '0 0 1 * *'
			}
		},

		// Sync campaigns from LOB
		syncCampaigns() {
			this.$syncCampaignsModal.hide()
			this.syncingCampaigns = true
			restApi
				.get('/deliveries/syncCampaigns', { params: { from: this.from, to: this.to } })
				.then(({ data }) => {
					this.syncingCampaigns = false
					if (data > 0) {
						this.$swal.fire({
							icon: 'success',
							title: `Synchronization of campaigns is done. Campaign deliveries synchronized ${data}`,
							timer: 7000,
						})
					} else {
						this.$swal.fire({
							icon: 'error',
							title: `There is no campaigns to synchronize!`,
							timer: 4000,
						})
					}
					this.clearSyncData()
				})
				.catch(error => {
					this.syncingCampaigns = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		clearSyncData() {
			this.from = null
			this.to = null
		},

		// Add sender
		addSender() {
			let sender = {
				name: '',
				address_line1: '',
				address_city: '',
				address_state: '',
				address_zip: '',
			}
			this.settings.senders.push(sender)
		},

		// Remove sender (not persisted until Save changes)
		removeSender(index) {
			this.settings.senders.splice(index, 1)
		},
	},
}
</script>
